import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { setOpenPrizeModal } from '../../../../../lib/redux/campaignPrize/campaignPrizeSlice';

import { Container, ErrorMsg } from './StyledComponents';

import Text from '../../../../../shared/Text';
import { ButtonBase } from '../../../../../shared/Button';

const Banner = ({ header, description, errors }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('posts');
  const hasError = useSelector(state => state.campaignPrize.hasError);

  return (
    <Wrapper className={hasError ? 'shakeX' : ''} $hasError={hasError}>
      <Header as="div">{header}</Header>
      <Description as="div" variant="subtitle2">
        {description}
      </Description>
      <ErrorMsg as="div" variant="subtitle2" $hasError={hasError}>
        {errors}
      </ErrorMsg>
      <EditPrizeBtn
        mode="text"
        variant="primary"
        onClick={() => dispatch(setOpenPrizeModal())}
      >
        <GiftIcon />
        {t('prizeBanner.editPrizes')}
      </EditPrizeBtn>
    </Wrapper>
  );
};

export default Banner;

const Wrapper = styled(Container)`
  padding: 20px;
  height: ${props => (props.$hasError ? '157px' : '118px')};
  ${props =>
    props.$hasError
      ? `background: linear-gradient(
          0deg, #FFF4F3 0%, #FFF4F3 100%),
          radial-gradient(
            347.82% 69.04% at 15.94% 50%,
            rgba(132, 153, 246, 0.10) 0%,
            rgba(237, 166, 138, 0.10) 100%
          );
        `
      : `background: radial-gradient(
            347.82% 69.04% at 15.94% 50%,
            rgba(132, 153, 246, 0.1) 0%,
            rgba(237, 166, 138, 0.1) 100%
          ),
          #fff
      `}
`;

const Header = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const Description = styled(Text)``;

const GiftIcon = styled.i.attrs({
  className: 'fa-light fa-gift',
})`
  margin-right: 5px;
`;

const EditPrizeBtn = styled(ButtonBase)`
  display: flex;
  align-items: center;
  padding: 6px 29px 6px 0px;
  margin-top: 5px;
  height: auto;
`;
